export default __webpack_public_path__ + "static/media/login.31d6cfe0.svg";